import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';

// Initialisation du thème depuis localStorage (norme : auto / light / dark)
const savedTheme = localStorage.getItem('hg_theme') || 'auto';
if (savedTheme === 'light') document.documentElement.classList.add('light');
else if (savedTheme === 'dark') document.documentElement.classList.add('dark');

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
